/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Colors, Animation } from "../../styles";
import { motion } from "framer-motion";
import FilterCategory from "./FilterCategory";

const renderCareerFilters = (
	careerFilters,
	selectedFilters,
	handleSelectFilter
) => (
	<FilterCategory
		careerFilters={careerFilters}
		selectedFilters={selectedFilters}
		handleSelectFilter={handleSelectFilter}
	/>
);

const MobileFiltersModal = ({
	careerFilters,
	selectedFilters,
	handleSelectFilter,
	clearAllFilters,
	closeModal,
}) => (
	<Overlay
		initial="closed"
		animate="opened"
		exit="closed"
		variants={Animation.modal.overlayVariants}
	>
		<Modal
			initial="closed"
			animate="opened"
			exit="exit"
			variants={Animation.modal.asideVariants}
			role="dialog"
		>
			<CloseIcon
				initial="closed"
				animate="open"
				exit="exit"
				variants={Animation.modal.closeIconVariants}
				icon={mainScript.assetPath + "images/svg/icons/icon-close.svg"}
				onClick={(e) => closeModal(e)}
				aria-label="Close modal"
			/>
			<ModalContent>
				{renderCareerFilters(
					careerFilters,
					selectedFilters,
					handleSelectFilter
				)}
			</ModalContent>
			{selectedFilters.length > 0 && (
				<ClearFiltersButton onClick={clearAllFilters}>
					Clear Filters
				</ClearFiltersButton>
			)}
		</Modal>
	</Overlay>
);

MobileFiltersModal.propTypes = {
	careerFilters: PropTypes.object.isRequired,
	selectedFilters: PropTypes.array.isRequired,
	handleSelectFilter: PropTypes.func.isRequired,
	clearAllFilters: PropTypes.func.isRequired,
	closeModal: PropTypes.func.isRequired,
};

export default MobileFiltersModal;

const Overlay = styled(motion.div)`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	cursor: pointer;
	width: 100vw;
	height: 100vh;
	z-index: 900;
	background: ${Colors.base.black};
`;

const Modal = styled(motion.div)`
	overflow: scroll;
	background-color: ${Colors.base.white};
	height: 100vh;
	width: 100%;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 1000;
	padding: 9.2rem 1.6rem 2.5rem;
`;

const ModalContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4rem;
`;

const CloseIcon = styled(motion.svg)`
	position: absolute;
	right: 3rem;
	top: 5rem;
	content: "";
	background: url(${(props) => props.icon && props.icon}) no-repeat;
	width: 29px;
	height: 29px;
	margin: 0.4rem 0 0 0.5rem;
	cursor: pointer;
`;

const ClearFiltersButton = styled.button`
	margin-top: 3rem;
	background: none;
	padding: 0;
	height: fit-content;
	text-align: left;
	color: ${Colors.base.black};
	font-weight: 600;
	text-transform: uppercase;
	font-size: 1rem;
	line-height: 1.6rem;
	letter-spacing: 0.705px;

	&:hover {
		font-weight: 900;
		box-shadow: none;
	}

	&:focus {
		box-shadow: none;
	}
`;
